module.exports = __webpack_public_path__ + "img/red_con.93e074ed.png";